module.exports = __webpack_public_path__ + "img/secondary_2x3_z18.f82f602d.svg";